import axiosApi from "scripts/components/react/api/ajaxToAxios"
import { apiRequest, ApiResult } from "scripts/types/api"
import type { ProfileOrder, IPagination } from "scripts/types"
import { ProfileOrderProps } from "../PersonalApp/ProfileOrder/ProfileOrder"

export type OrdersApiData = { orderList: ProfileOrder[]; pagination: IPagination }
type OrderApiResponse = { order: ProfileOrderProps["order"] }
type OrderPaymentResponse = { link: string }

export const fetchOrders = (page: number = 1): Promise<ApiResult<OrdersApiData>> =>
  apiRequest(axiosApi(`/api/orders/?page=${page}`, {}))

export const fetchOrder = (orderName: string): Promise<ApiResult<OrderApiResponse>> =>
  apiRequest(axiosApi(`/api/orders/${orderName}/`, {}))

export const payOrder = (orderName: string): Promise<ApiResult<OrderPaymentResponse>> =>
  apiRequest(axiosApi(`/api/orders/payment/${orderName}/`, { method: "GET" }))
